export const LABEL_PROVIDER = {
    INTERNAL: 'internal',
    MERCADO_ENVIOS_FLEX: 'mercado_envios_flex'
}